import { useEffect, useMemo, useState } from "react";

function useSubscriptionSelectorManager(
  initialPlanId,
  plans,
  onReloadPlanData,
  reloadIntervalSec = 15
) {
  const [selectedPlan, setSelectedPlan] = useState(initialPlanId);
  const [actionableClicked, setActionableClicked] = useState();

  const hasNonEligiblePlan = useMemo(() => {
    return plans.some(({ eligibility }) => {
      return !eligibility.eligible;
    });
  }, [plans]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (hasNonEligiblePlan && actionableClicked) onReloadPlanData();
    }, reloadIntervalSec * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [
    hasNonEligiblePlan,
    actionableClicked,
    onReloadPlanData,
    reloadIntervalSec,
  ]);

  return {
    selectedPlan: selectedPlan,
    setSelectedPlan: setSelectedPlan,
    showPlanReloadButton: actionableClicked,
    onSuggestedHintClicked: setActionableClicked,
  };
}

export default useSubscriptionSelectorManager;
